import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

/**
 * Firebase Configuration
 * Using environment variables for security and portability.
 * Define these in your .env or on your hosting provider (Vercel/Netlify/Railway).
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDZDSUxmahHlidKsGy8SQJNeB-1SbcG1sM",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "prindox-d0415.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "prindox-d0415",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "prindox-d0415.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "556245030226",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:556245030226:web:191d0860235b54d146968b",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-S5J91J62R3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Language set to Indian English
auth.languageCode = 'en-IN';

/**
 * Setup Invisible reCAPTCHA
 * Returns a new verifier instance. The caller is responsible for cleanup.
 */
export const setupRecaptcha = (containerId: string) => {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`reCAPTCHA container #${containerId} not found`);
    return null;
  }

  // Clear container HTML to be absolutely sure no leftover iframes exist
  container.innerHTML = '';
  
  console.log(`[Firebase] Setting up reCAPTCHA for domain: ${window.location.hostname} on #${containerId}`);

  try {
    const verifier = new RecaptchaVerifier(auth, containerId, {
      'size': 'invisible',
      'callback': (response: any) => {
        console.log("reCAPTCHA solved:", response);
      },
      'expired-callback': () => {
        console.log("reCAPTCHA expired");
      }
    });

    // Essential: Force the verifier to use the specific auth instance
    (verifier as any)._auth = auth;

    // Render only if not already rendered
    verifier.render().catch(err => {
      if (!err.message?.includes("already been rendered")) {
        console.error("reCAPTCHA render error:", err);
      }
    });

    return verifier;
  } catch (err) {
    console.error("Failed to setup reCAPTCHA:", err);
    return null;
  }
};
